import React from 'react';

import { KeyOutlined, ApiOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const EasyStoreCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const accessTokenDirty = useDirtyMaskedField(form, [ 'credentials', 'access_token' ], isEditing);

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_domain']}
            label={t('models.ec_account.platform_settings.easy_store.api_domain')}
            rules={[
              { required: true, message: t('models.ec_account.platform_settings.easy_store.api_domain_required') },
              { pattern: /^https:\/\/.*/, message: t('models.ec_account.platform_settings.easy_store.api_domain_pattern') }
            ]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.easy_store.api_domain_placeholder')}
              prefix={<ApiOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'access_token']}
            label={t('models.ec_account.platform_settings.easy_store.access_token')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.easy_store.access_token_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.easy_store.access_token_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={accessTokenDirty}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default EasyStoreCredentials;
